module.exports = __webpack_public_path__ + "static/media/archive.90908667.svg";